import { APP_DOMAIN, VERCEL_URL } from 'constants/process'
import { useRouter } from 'next/router'
import _entries from 'lodash-es/entries'
import _omit from 'lodash-es/omit'

export const useRedirectToMainDomain = (): { redirectUrl?: string } => {
  const mainDomain = APP_DOMAIN || VERCEL_URL

  const { query, pathname } = useRouter()

  const isRedirectingFromJobBoard =
    query['redirecting-from-job-board'] === 'true'

  const { protocol } = window.location

  if (!isRedirectingFromJobBoard) return { redirectUrl: null }

  const search = new URLSearchParams()

  _entries(_omit(query, ['redirecting-from-job-board'])).forEach(
    ([key, value]) => search.append(key, `${value}`)
  )

  const redirectUrl = `${protocol}//${mainDomain}${pathname}?${search}`

  return { redirectUrl }
}
